import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 md:py-24 px-4 bg-mystic-900 relative overflow-hidden" data-id="element-41">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-mystic-800" data-id="element-42"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-gold/10 filter blur-[100px] rounded-full pointer-events-none" data-id="element-43"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold mb-6 md:mb-8 text-white" data-id="element-45">
          Hacé clic y empezá hoy.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} data-id="element-46">
          <Button onClick={scrollToPricing} className="text-base md:text-xl px-8 py-4 md:px-12 md:py-6 shadow-[0_0_30px_rgba(212,168,83,0.3)]" data-id="element-47">
            ACCEDER AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}